import type { IAssetInstallationPoint } from '../model/assetEquipment';
import { selectSensorAiType } from '../store/useSensorStore';

export const getPointStatusType = (point: IAssetInstallationPoint) => {
  const sensorAiType = selectSensorAiType();

  if (point.statusType === 'deactivated') {
    return point.statusType;
  }

  if (sensorAiType === 'regular') {
    return point.regularAi ? point.statusType : 'normal';
  }
  if (sensorAiType === 'waitesWireless') {
    return point.wwAi ? point.statusType : 'normal';
  }

  return point.statusType;
};
